import React from "react";

export interface TitleProps {
  children: React.ReactNode;
}

export const Title = ({ children }: TitleProps) => (
  <div className="cw-heading-3xl cw-mb-5">{children}</div>
);
